import { faArrowUp } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@karnov/kui-react'

import { RefObject, useEffect, useRef, useState, type FC } from 'react'

import { useTranslation } from 'services/i18n'

type Props = {
  panelRef: RefObject<HTMLElement>
}

export const ScrollToTopButton: FC<Props> = ({ panelRef }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation_history',
  })

  const previousScrollTopRef = useRef(0)
  const [showScrollToTopButton, setShowScrollToTopButton] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (!panelRef?.current) return

      if (panelRef.current.scrollTop >= previousScrollTopRef.current) {
        setShowScrollToTopButton(true)
      }
      else {
        setShowScrollToTopButton(false)
      }
      previousScrollTopRef.current = panelRef.current.scrollTop
    }

    const panel = panelRef?.current
    panel?.addEventListener('scroll', handleScroll)

    return () => {
      panel?.removeEventListener('scroll', handleScroll)
    }
  }, [panelRef])

  const handleClick = () => panelRef?.current?.scrollTo({ top: 0, behavior: 'smooth' })

  return (
    <div className="z-10 mt-2 flex w-full justify-center">
      <div className="h-8">
        {showScrollToTopButton && (
          <Button
            isRounded
            isSmall
            icon={faArrowUp}
            onClick={handleClick}
            aria-label={t('go_to_top')}
          />
        )}
      </div>
    </div>
  )
}
